/* lystia-cart-drawer.js - шторка кошика (T-E5-01, parity/cart.md §2-§4).
   Підключення: snippets/cart-drawer.liquid (defer, після lystia-core/cart/overlay/qty з layout).
   Розмітку (тіло/підвал/заголовок) віддає секція `cart-drawer` (Section Rendering API); тут:
   - cart:change -> підтягнути ?sections=cart-drawer і підмінити тіло/підвал/заголовок шторки (scrollTop зберігається);
   - cart:loading -> клас .is-updating на панелі (ціни -> скелети);
   - зміна кількості (lystia-qty:change) -> LystiaCart.setQty; помилка -> стан «помилка кількості» з «Повторити»;
   - помилка завантаження -> стан error (шаблони data-cart-tpl) + «Спробувати ще раз» (700 мс);
   - новий рядок (reason add, шторка відкрита) -> .is-new (cp-in 380 мс).
   Видалення рядка (кнопка «Видалити», swipe, qty 0): подія 'lystia:cart-line-remove' (cancelable) на рядку;
   T-E5-02 перехоплює її (preventDefault) і робить анімацію + «Повернути»; без неї - пряме видалення. */
(function () {
  'use strict';
  var core = document.lystia;
  var cartApi = window.LystiaCart;
  if (!core || !cartApi) { console.error('[lystia-cart-drawer] потрібні lystia-core.js і lystia-cart.js'); return; }
  if (document.lystiaCartDrawer) return;

  var NAME = 'cart';
  var SECTION = 'cart-drawer';
  var RETRY_MS = 700;

  var seq = 0;          /* номер останнього оновлення (застарілі відповіді ігноруються) */
  var inflight = 0;     /* оновлення в польоті */
  var focusKey = null;  /* рядок, на «+» якого повертаємо фокус після оновлення (лише desktop) */

  function host() { return document.querySelector('lystia-overlay[name="' + NAME + '"]'); }
  function overlay() { return document.lystiaOverlay; }
  function panel() { return overlay() && overlay().isOpen(NAME) ? overlay().panel() : null; }
  function tpl(host, name) { return host.querySelector('[data-cart-tpl="' + name + '"]'); }
  function container(h) { return h.closest('[data-cart-drawer]') || document; }
  function isDesktop() { return core.device() === 'desktop'; }

  function setUpdating(on) {
    var p = panel();
    if (!p) return;
    p.classList.toggle('is-updating', on);
    if (on) p.setAttribute('aria-busy', 'true'); else p.removeAttribute('aria-busy');
  }

  function setTitle(text) {
    var h = host();
    if (h) h.setAttribute('heading', text);
    var p = panel();
    if (!p) return;
    var t = p.querySelector('.ov__title');
    if (t) t.textContent = text;
    var dlg = p.closest('.ov');
    if (dlg) dlg.setAttribute('aria-label', text);
  }

  /* Підміна тіла/підвалу зі збереженням scrollTop */
  function swap(h, bodyHtml, footerHtml, title, added) {
    var p = panel();
    var bodyEl = p && p.querySelector('.ov__body');
    var top = bodyEl ? bodyEl.scrollTop : 0;
    var hadFocus = !!(p && p.contains(document.activeElement) && document.activeElement !== p.querySelector('.ov__close'));
    h.setBody(bodyHtml);
    h.setFooter(footerHtml && footerHtml.trim() ? footerHtml : null);
    setTitle(title);
    if (!p) return;
    if (bodyEl) bodyEl.scrollTop = top;
    if (added) {
      Array.prototype.forEach.call(p.querySelectorAll('.cp-line'), function (row) {
        if (row.getAttribute('data-variant-id') === String(added)) row.classList.add('is-new');
      });
    }
    var restored = false;
    if (focusKey && isDesktop()) {
      var plus = p.querySelector('[data-line-key="' + focusKey + '"] [data-qty-plus]:not(:disabled)');
      if (plus) { try { plus.focus({ preventScroll: true }); restored = true; } catch (e) { /* ignore */ } }
    }
    focusKey = null;
    if (!restored && hadFocus && !p.contains(document.activeElement)) {
      var dlg = p.closest('.ov');
      if (dlg) { try { dlg.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    }
  }

  function showError() {
    var h = host();
    if (!h) return;
    var body = tpl(container(h), 'error-body');
    var foot = tpl(container(h), 'error-footer');
    var title = tpl(container(h), 'error-title');
    swap(h, body ? body.innerHTML : '', foot ? foot.innerHTML : '', title ? title.innerHTML.trim() : '', null);
  }

  async function fetchSection() {
    /* без Accept: application/json - інакше на сторінках товару/колекції сервер віддає JSON ресурсу, а не секцій */
    var res = await fetch(window.location.pathname + '?sections=' + SECTION, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('http_' + res.status);
    var data = await res.json();
    if (!data || !data[SECTION]) throw new Error('no_section');
    return data[SECTION];
  }

  function render(html, added) {
    var h = host();
    if (!h) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('lystia-overlay[name="' + NAME + '"]');
    var body = fresh && fresh.querySelector(':scope > template[data-slot="body"]');
    if (!fresh || !body) throw new Error('bad_section');
    var foot = fresh.querySelector(':scope > template[data-slot="footer"]');
    swap(h, body.innerHTML, foot ? foot.innerHTML : '', fresh.getAttribute('heading') || '', added);
  }

  /** Оновлення шторки з сервера. html - вже отриманий Section Rendering (необов'язково). */
  async function refresh(opts) {
    opts = opts || {};
    var my = ++seq;
    inflight++;
    try {
      var html = opts.html || (await fetchSection());
      if (my !== seq) return;
      render(html, opts.added);
    } catch (e) {
      if (my === seq) showError();
    } finally {
      inflight--;
      if (my === seq) setUpdating(false);
    }
  }

  /* ---------- події кошика ---------- */
  document.addEventListener('cart:loading', function (e) {
    if (e.detail && e.detail.active) setUpdating(true);
    else if (!inflight) setUpdating(false);
  });
  document.addEventListener('cart:change', function (e) {
    var d = e.detail || {};
    var added = d.reason === 'add' && overlay() && overlay().isOpen(NAME) ? d.id : null;
    var html = d.sections && d.sections[SECTION];
    refresh({ html: html || null, added: added });
  });
  document.addEventListener('cart:error', function () {
    if (!inflight) setUpdating(false);
  });

  /* ---------- рядок: кількість, видалення, повтор ---------- */
  function rowOf(el) { return el.closest && el.closest('.ov-name--' + NAME + ' [data-line-key]'); }

  function lineError(row, on) {
    var qty = row.querySelector('lystia-qty');
    var err = row.querySelector('.cp-line__err');
    if (err) err.hidden = !on;
    if (qty && qty.setState) qty.setState(on ? 'error' : 'default');
  }

  function removeLine(row) {
    var detail = { key: row.getAttribute('data-line-key'), variantId: row.getAttribute('data-variant-id'), qty: Number(row.getAttribute('data-qty')) || 1, row: row };
    var ev = new CustomEvent('lystia:cart-line-remove', { bubbles: true, cancelable: true, detail: detail });
    if (row.dispatchEvent(ev)) cartApi.remove(detail.key).catch(function () { /* cart:error вже випущено */ });
  }

  document.addEventListener('lystia-qty:change', function (e) {
    var row = rowOf(e.target);
    if (!row) return;
    var v = e.detail.value;
    var key = row.getAttribute('data-line-key');
    lineError(row, false);
    if (v === 0) { removeLine(row); return; }
    focusKey = key;
    cartApi.setQty(key, v).catch(function () {
      focusKey = null;
      var qty = row.querySelector('lystia-qty');
      if (qty && qty.setValue) qty.setValue(Number(row.getAttribute('data-qty')) || 1);
      lineError(row, true);
    });
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-line-remove],[data-line-swipe-remove],[data-line-retry],[data-cart-retry]');
    if (!t || !t.closest('.ov-name--' + NAME)) return;
    if (t.hasAttribute('data-line-retry')) {
      var row = rowOf(t);
      if (row) lineError(row, false);
      refresh();
      return;
    }
    if (t.hasAttribute('data-cart-retry')) {
      t.classList.add('is-loading');
      t.setAttribute('aria-busy', 'true');
      var label = t.querySelector('.btn__label');
      if (label) { label.replaceChildren(); var sp = document.createElement('span'); sp.className = 'spinner'; sp.setAttribute('aria-hidden', 'true'); label.appendChild(sp); }
      setTimeout(function () { refresh(); }, RETRY_MS);
      return;
    }
    var line = rowOf(t);
    if (line) removeLine(line);
  });

  /* UPSELL (T-E5-05): «+» у «Спробуй також» - додає 1 шт. мінімального доступного варіанта, без тосту */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cart-up-add]');
    if (!b || !b.closest('.ov-name--' + NAME) || b.disabled) return;
    b.disabled = true;
    cartApi.add({ id: Number(b.getAttribute('data-variant-id')), quantity: 1 }).catch(function () { b.disabled = false; /* cart:error вже випущено */ });
  });

  /* Повернення зі сторінки з bfcache: тихе оновлення, якщо шторка закрита (відкрита - не чіпаємо фокус) */
  function quiet() { if (!overlay() || !overlay().isOpen(NAME)) refresh(); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) quiet(); });

  document.lystiaCartDrawer = Object.freeze({ refresh: refresh });
})();
